import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../../utility/framerMotionAnimations';
import './EmiCalculator.css';

const HeroSection = () => {
    return (
        <section className="emi-hero-section">
            <div className="emi-hero-container">
                <motion.div 
                    className="emi-hero-content"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInUp}
                >
                    <motion.div 
                        className="emi-hero-title-container"
                        variants={fadeInUp}
                    >
                        <motion.img 
                            src="/images/commercial-vehicle-emi.png" 
                            alt="Chart Icon" 
                            className="emi-hero-icon"
                            variants={fadeInUp}
                        />
                        <motion.h1 
                            className="emi-hero-title"
                            variants={fadeInUp}
                            transition={{ delay: 0.1 }}
                        >
                            Plan Smartly with Our EMI Calculator
                        </motion.h1>
                    </motion.div>
                    <motion.p 
                        className="emi-hero-description"
                        variants={fadeInUp}
                        transition={{ delay: 0.2 }}
                    >
                        Calculate your monthly loan installments quickly and easily to make informed financial decisions.
                    </motion.p>
                </motion.div>
            </div>
        </section>
    );
};

export default HeroSection;

